import React from 'react';

interface AutocompleteFormatFremdnummerProps {
  suchvorschlag?: any;
}

export const AutocompleteFormatFremdnummer = ({
  suchvorschlag,
}: AutocompleteFormatFremdnummerProps) => {
  const mc =
    suchvorschlag['matchcode'] === null
      ? ''
      : ' (' + suchvorschlag['matchcode'] + ')';

  return (
    suchvorschlag && (
      <span>
        {suchvorschlag[`fremdnummer`]} {mc}
        {' - '}
        {suchvorschlag[`name`]}, {suchvorschlag[`zeile2`]},{' '}
        {suchvorschlag[`strasse`]} {suchvorschlag[`hausnummer`]}
        <br />
        {suchvorschlag[`lkz`]} {suchvorschlag[`plz`]} {suchvorschlag[`ort`]}
      </span>
    )
  );
};
